import React, {Fragment, useState} from "react";
import {ifCompletedInput} from "../../../../../utils/other";
import {MultiSelect} from "primereact/multiselect";
import TextInput from "../../../TextInput";
import classNames from "classnames";
import {Dropdown} from "primereact/dropdown";
import {GUIProps} from "./Types/GUIProps";
import {defaultPageSizes} from "../defaults";
import Actions from "./Actions";
import Button from "../../../Button";
import Confirm from "../../../Confirm";
import Portal from "../../../../layout/Portal";
import Modal from "../../../../layout/Modal";

const ChangePage = (props) => {
    const [page, setPage] = useState(props.currpage);

    const changePage = (e, field, page) => {
        const pagecount = props.pagecount;
        if (!page) return;
        if (e.which === 38) {page++;}
        if (e.which === 40) {page--;}
        const pageNum = (props.request.itemsperpage === 0 ? 0 : Math.min(pagecount, Math.max(1, page)));
        setPage(pageNum);
        if (e.which !== 38 && e.which !== 40 && ifCompletedInput(e)) {
            props.loadData({...props.request, page: pageNum});
        }
    }

    if (props.pagecount <= 1) return null;

    return <Confirm
        header="Oldalszám"
        body={
            <TextInput
                className="p-page-number"
                label={false}
                type="number"
                value={page}
                onKeyDown={changePage}
                onBlur={changePage}
            />
        }
        onAccept={() => {
            props.loadData({...props.request, page});
        }}
    >
        {/*<span className="p-paginator-current">{props.pagecount}</span>*/}
        <span className="p-paginator-page p-paginator-element p-link">...</span>
    </Confirm>;
}

export default class Pagination extends React.Component<GUIProps, {pageSize?: number,changePageSize?: boolean, currentPageSize?: number}> {

    static defaultProps = {
        pageSizes: defaultPageSizes
    }

    constructor(props: Readonly<GUIProps>) {
        super(props);
        this.state = {
            pageSize: this.props.pageSize,
            changePageSize: false,
            currentPageSize: this.props.request.itemsperpage,
        }
        this.getPageCount = this.getPageCount.bind(this);
        this.changePageNumber = this.changePageNumber.bind(this);
    }

    componentDidUpdate(prevProps: Readonly<GUIProps>, prevState: Readonly<{}>, snapshot?: any) {
        if (this.props.pageSize !== prevProps.pageSize) {
            this.setState({
                pageSize: this.props.pageSize
            });
        }
        if (this.props.request.itemsperpage !== prevProps.request.itemsperpage) {
            this.setState({
                currentPageSize: this.props.request.itemsperpage
            });
        }
    }

    getPageCount() {
        return this.props.data.navigation.pagecount;
    }

    changePageNumber(event) {
        if (!isNaN(event.value)) {
            this.props.loadData({...this.props.request, itemsperpage: event.value, page: 1});
            this.setState({
                changePageSize: false
            });
        } else {
            this.setState({changePageSize: true});
        }
    }

    changeCurrentPageSize = (e, field, page) => {
        if (!page) return;
        if (e.which === 38) {page++;}
        if (e.which === 40) {page--;}
        const pageNum = Math.max(1, page);
        this.setState({currentPageSize: pageNum});
        if (e.which !== 38 && e.which !== 40 && ifCompletedInput(e)) {
            this.changePageNumber({value: pageNum});
        }
    }

    render() {
        const pageSize = this.props.request.itemsperpage;
        if (pageSize <= 0) return null;
        const pagecount = this.getPageCount();
        const currpage = Math.min(this.props.data.navigation.currpage, pagecount);
        let pageSizes: (number|string)[] = this.props.pageSizes;
        if (!pageSizes.find((v) => v === pageSize)) {
            pageSizes = [pageSize, ...pageSizes];
        }
        pageSizes = [...pageSizes, "..."].sort((a,b) => {
            if (!Number.isNaN(a) && !Number.isNaN(b)) {
                return a - b;
            } else if (!Number.isNaN(a)) {
                return -1;
            } else {
                return 1;
            }
        });
        let visibleFields = [...this.props.visibleFields];
        let alwaysVisible = [];
        let possibleVisibleFields = this.props.getFields().map((field) => {
            if (field.props.label === false) {
                const index = visibleFields.indexOf(field.props.field);
                if (index !== -1) {
                    alwaysVisible = [...alwaysVisible, ...visibleFields.splice(index, 1)];
                }
                return null;
            }
            let column = this.props?.data?.columns?.[field]?.label;
            let label = column === field ? null : column;
            return {
                label: label || field.props.header || column || field,
                value: field.props.field
            }
        }).filter((v) => !!v);
        let paginationRight = this.props.paginationRight || null;
        if (paginationRight) {
            if (paginationRight instanceof Function) {
                const PaginationRight = paginationRight;
                paginationRight = <PaginationRight {...this.props} />;
            } else {
                paginationRight =
                    <paginationRight.type ref={paginationRight.ref} {...paginationRight.props} {...this.props} />;
            }
        }
        let viewSelector = this.props.viewSelector;
        if (viewSelector === undefined) {
            viewSelector = <MultiSelect
                className={Object.keys(possibleVisibleFields).length === visibleFields.length ? "all-column-selected" : ""}
                disabled={this.props.isLoading}
                selectedItemTemplate={() => <i className="p-selected-icon fa fa-th-list"/>}
                value={visibleFields}
                options={possibleVisibleFields}
                onChange={(event) => this.props.setVisibleFields([...alwaysVisible, ...event.value])}
            />;
        }
        return (
            <div className="p-paginator p-component p-unselectable-text p-paginator-bottom">
                <Portal>
                    <Modal
                        header="Darabszám"
                        state={this.state.changePageSize}
                        buttons={[
                            {
                                text: "Mégse",
                                props: {
                                    color: "default"
                                },
                                onClose: true,
                                onClick: () => {
                                    this.setState({
                                        changePageSize: false,
                                        currentPageSize: this.props.request.itemsperpage
                                    });
                                }
                            },
                            {
                                text: "Mehet",
                                props: {
                                    color: "primary"
                                },
                                onClick: () => {
                                    this.changePageNumber({value: this.state.currentPageSize});
                                }
                            }
                        ]}
                    >
                        <TextInput
                            type="number"
                            label={false}
                            value={this.state.currentPageSize}
                            onBlur={this.changeCurrentPageSize}
                            onKeyDown={this.changeCurrentPageSize}
                        />
                    </Modal>
                </Portal>
                <div className="p-paginator-left-content">
                    {viewSelector}
                    {this.props.paginationLeft}
                </div>
                <button
                    className={classNames("p-paginator-prev p-paginator-element p-link", {"p-disabled": currpage <= 1})}
                    disabled={currpage <= 1}
                    onClick={(e) => {
                        e.preventDefault();
                        this.props.loadData({...this.props.request, page: currpage - 1})
                    }}
                >
                    <span
                        className="p-paginator-icon pi pi-caret-left"
                    />
                </button>
                <span className="p-paginator-pages">
                    {currpage > 4 && <Fragment>
                        <button
                            className={classNames("p-paginator-first p-paginator-element p-link", {"p-disabled": currpage <= 1})}
                            disabled={currpage <= 1}
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.loadData({...this.props.request, page: 1})
                            }}
                        >
                            1
                        </button>
                        {currpage > 5 && <ChangePage {...this.props} pagecount={pagecount} currpage={currpage} />}
                    </Fragment>}
                    {[-3,-2,-1,0,+1,+2,+3].map((page, idx) => {
                        page = currpage + page;
                        if (page > 0 && page <= pagecount) {
                            return <button
                                key={idx}
                                className={classNames("p-paginator-page p-paginator-element p-link", {"p-highlight": page === currpage})}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.props.loadData({...this.props.request, page})
                                }}
                            >
                                {page}
                            </button>
                        }
                    })}
                    {currpage + 3 < pagecount && <Fragment>
                        {currpage + 4 !== pagecount && <ChangePage {...this.props} pagecount={pagecount} currpage={currpage} />}
                        <button
                            className={classNames("p-paginator-last p-paginator-element p-link", {"p-disabled": currpage == pagecount})}
                            disabled={currpage == pagecount}
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.loadData({...this.props.request, page: pagecount})
                            }}
                        >
                            {pagecount}
                        </button>
                    </Fragment>}
                </span>
                <button
                    className={classNames("p-paginator-next p-paginator-element p-link", {"p-disabled": currpage == pagecount})}
                    disabled={currpage == pagecount}
                    onClick={(e) => {
                        e.preventDefault();
                        this.props.loadData({...this.props.request, page: currpage + 1})
                    }}
                >
                    <span
                        className="p-paginator-icon pi pi-caret-right"
                    />
                </button>
                <Dropdown
                    value={pageSize}
                    options={pageSizes.map((pageSize) => ({label: String(pageSize), value: pageSize}))}
                    onChange={this.changePageNumber}
                />
                <div className="p-paginator-right-content">
                    {paginationRight}
                    <Actions {...this.props} />
                    <Button
                        onClick={() => this.props.loadData(this.props.request)}
                        color="default"
                        icon={{lib: "fa", name: "refresh", spin: this.props.isLoading}}
                        disabled={this.props.isLoading}
                    />
                </div>
            </div>
        );
    }
}